import getAngleBetweenPoints from "../../../../../../../src/utils/math/getAngleBtwPoints";
import { normalizeRadian } from "../../../../../../../src/utils/math/normalizeRadian";
import { Coord, RedPointRadianInfo } from "../../../../../../../src/types/Interface";
import RedPoint from "../../../../../../../src/entities/RedPoint";
import { moveAllPointAnim } from "../../../../../../../src/animation/Circle/helpers/drawHelpers";
import PointManager from "../PointManager";
import { THRESHOLD_RADIAN } from "../../../types/Config";


export function findIntersection(cCoord: Coord, pointA: Coord, pointB: Coord) {
  // y = m * x + b
  const slopeA = Math.tan(normalizeRadian(getAngleBetweenPoints(pointA, cCoord) + Math.PI / 2));
  const slopeB = Math.tan(normalizeRadian(getAngleBetweenPoints(pointB, cCoord) + Math.PI / 2));

  // b = y - m * x
  const bA = pointA.y - slopeA * pointA.x;
  const bB = pointB.y - slopeB * pointB.x;

  // x = (b2 - b1) / (m1 - m2)
  const x = Number(((bB - bA) / (slopeA - slopeB)).toFixed(2));
  const y = Number((slopeB * x + bB).toFixed(2));
  return { x, y }
}

export function generateRandomlyRadians(PointManager: PointManager) {
  const OffsetUnit = THRESHOLD_RADIAN / 5
  const randomOffsetB = OffsetUnit + Math.random() * (THRESHOLD_RADIAN - OffsetUnit);
  const randomA = normalizeRadian(Math.random() * (Math.PI * 2));
  const randomB = normalizeRadian(randomA + randomOffsetB);
  const newRadians = [randomA, randomB];
  const RefRadians = PointManager.getRefRadians();
  const points = PointManager.getRedPoints();

  newRadians.map((v: number) => (v * (Math.PI / 3))).sort().reverse();
  moveAllPointAnim(RefRadians, newRadians, (radian: number, index: number) => {
    PointManager.setRadian([{ pTag: points[index].tag, radian }])
  });
}

export function findTangentCoords(cCoord: Coord, pointA: Coord, pointB: Coord, clockwise: boolean) {
  const length = 80;
  const slopeA = normalizeRadian(getAngleBetweenPoints(pointA, cCoord) + (clockwise ? 1 : -1) * Math.PI / 2);
  const slopeB = normalizeRadian(getAngleBetweenPoints(pointB, cCoord) + (clockwise ? -1 : 1) * Math.PI / 2);

  const tangentA = {
    x: Math.cos(slopeA) * length + pointA.x,
    y: Math.sin(slopeA) * length + pointA.y
  }
  const tangentB = {
    x: Math.cos(slopeB) * length + pointB.x,
    y: Math.sin(slopeB) * length + pointB.y
  }
  return [tangentA, tangentB]
}

export function getShortestDelta(a: number, b: number): number {
  let delta = a - b;
  while (delta > Math.PI) delta -= 2 * Math.PI;
  while (delta < -Math.PI) delta += 2 * Math.PI;
  return delta;
}

export function getPointInfoArr(pointInfoArr: RedPointRadianInfo[], RedPointsArr: RedPoint[], pointRadians: number[]) {
  let _pointInfoArr: RedPointRadianInfo[] = [...pointInfoArr];

  if (pointInfoArr.length === 1) {
    const index = RedPointsArr.findIndex(point => point.tag === pointInfoArr[0].pTag);
    const otherIndex = index === 0 ? 1 : 0;
    const firstRadian = normalizeRadian(pointInfoArr[0].radian);
    const secondOriginalRadian = normalizeRadian(pointRadians[otherIndex]);

    const delta = getShortestDelta(firstRadian, secondOriginalRadian);
    let secondRadian = secondOriginalRadian;

    if (Math.abs(delta) > THRESHOLD_RADIAN) {
      if (delta > 0) {
        secondRadian = firstRadian - THRESHOLD_RADIAN;
      } else {
        secondRadian = firstRadian + THRESHOLD_RADIAN;
      }
      _pointInfoArr.push({ pTag: RedPointsArr[otherIndex].tag, radian: secondRadian });
    }
  }
  return _pointInfoArr
}
